/**
 * 异步延迟函数
 * @param time - 延迟毫秒数
 */
export function sleep(time: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, time));
}
